import { ErrorBoundary, FallbackProps } from 'react-error-boundary';

export const DefaultErrorBoundaryFallback: React.FC<FallbackProps> = ({ error, resetErrorBoundary }) => (
  <div role="alert">
    <p>Something went wrong:</p>
    <pre>{error.message}</pre>
    <button onClick={resetErrorBoundary}>Try again</button>
  </div>
);

export const defaultErrorBoundaryHandler = () => {};

interface ErrorBoundaryWrapperProps {
  children: React.ReactNode;
  FallbackComponent?: React.ComponentType<FallbackProps>;
  onReset?: () => void;
}

const ErrorBoundaryWrapper: React.FC<ErrorBoundaryWrapperProps> = ({
  children,
  FallbackComponent = DefaultErrorBoundaryFallback,
  onReset = defaultErrorBoundaryHandler,
}) => (
  <ErrorBoundary FallbackComponent={FallbackComponent} onReset={onReset}>
    {children}
  </ErrorBoundary>
);

export default ErrorBoundaryWrapper;
